'use client'

// src/trackers/gtm/types.ts
var GTM_EVENTS = [
  "user_subscription_plan",
  "bookings_page_flights_tab_clicked",
  "bookings_page_card_clicked",
  "clicked_select_plan",
  "clicked_on_upgrade_purchase_priority",
  "clicked_on_upgrade_continue_purchase_priority",
  "clicked_on_upgrade_booking_limit",
  "clicked_on_upgrade_continue_booking_limit",
  "clicked_on_jump_queue",
  "clicked_on_jump_queue_authenticate",
  "clicked_on_upgrade_continue_jump_queue",
  "clicked_on_select_dates",
  "clicked_on_search",
  "clicked_on_category",
  "clicked_on_tags",
  "clicked_on_section_item",
  "clicked_on_join_auction",
  "clicked_on_top_up_wallet",
  "clicked_on_start_bidding",
  "clicked_on_verify_email",
  "confirm_bid",
  "increase_bid",
  "search",
  "flights_home_search_started",
  "flights_home_origin_selected",
  "flights_home_destination_selected",
  "flights_home_departure_date_selected",
  "flights_home_return_date_selected",
  "flights_results_page_loaded",
  "flights_results_sort_applied",
  "flights_results_filter_applied",
  "flights_summary_page_loaded",
  "flights_login_page_loaded",
  "flights_passengers_details_page_loaded",
  "flights_add_passenger_clicked",
  "flights_home_page_loaded",
  "flights_proceed_to_payment_clicked",
  "flights_pax_details_page_loaded",
  "flights_pax__details_error_occurred",
  "flights_payment_method_selected",
  "flights_summary_page_loaded",
  "flights_confirmation_page_loaded",
  "flights_pax__details_add_pax_clicked",
  "flights_results_filter_applied",
  "flights_results_sort_applied",
  "flights_pax__details_continue_clicked",
  "flights_pax__details_traveller_added",
  "force_update_screen_exit",
  "force_update_screen_save_info",
  "force_update_banner_spotlight_clicked"
];

export {
  GTM_EVENTS
};
//# sourceMappingURL=chunk-PM7Z2EMU.mjs.map